<script setup lang="ts">
import type { JsonFieldProps } from './types'

import { Button } from '@/shared/ui/button'
import { Textarea } from '@/shared/ui/textarea'

const model = defineModel<string>({ default: '' })
const props = withDefaults(defineProps<JsonFieldProps>(), {
  label: '',
  description: '',
  errorMessage: '',
  nullLabel: '',
  defaultLabel: '',
  disabled: false,
  rows: 7,
})
const emit = defineEmits<{ 'set-null': []; 'set-default': [] }>()

function setNull(): void {
  if (!props.spec.nullable || props.disabled) return
  model.value = 'null'
  emit('set-null')
}

function setDefault(): void {
  if (props.disabled) return
  model.value = JSON.stringify(props.spec.defaultValue, null, 2)
  emit('set-default')
}
</script>

<template>
  <div class="ui-json-field grid gap-2xs">
    <Textarea
      v-model="model"
      :label="label"
      :rows="rows"
      :disabled="disabled"
      :error="Boolean(errorMessage)"
      :error-message="errorMessage"
      spellcheck="false"
    />
    <div
      v-if="description || nullLabel || defaultLabel"
      class="ui-json-field__meta flex items-start justify-between gap-sm"
    >
      <p v-if="description" class="m-0 text-muted text-xs">{{ description }}</p>
      <div class="ui-json-field__actions flex shrink-0 gap-2xs">
        <Button
          v-if="spec.nullable && nullLabel"
          type="button"
          size="xs"
          variant="ghost"
          :disabled="disabled"
          @click="setNull"
        >
          {{ nullLabel }}
        </Button>
        <Button
          v-if="defaultLabel"
          type="button"
          size="xs"
          variant="ghost"
          :disabled="disabled"
          @click="setDefault"
        >
          {{ defaultLabel }}
        </Button>
      </div>
    </div>
  </div>
</template>
